import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; // NEW
import AOS from "aos";
import "aos/dist/aos.css";

const People = () => {
const location = useLocation();

useEffect(() => {
  AOS.init({ duration: 1200, once: false });
  AOS.refresh();
}, [location.pathname]);
  return (
    <div className="font-sans text-[#144E73]">
      {/* SECTION 1: About the Benecke Group – White background, text left, image right */}
      <section className="bg-white py-20 px-6">
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center"
          data-aos="fade-up"
        >
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">About the Benecke Group</h2>
            <p className="text-lg leading-relaxed">
              Founded in the 1960s, the Benecke Group is a proudly family-owned business rooted in South Africa’s Vaal Triangle. What began as a single hotel has grown into a multi-generational enterprise spanning accommodation, restaurants, and property rentals — all managed with heart, hospitality, and a hands-on approach.
            </p>
          </div>
          <img src="/rita_johan.jpg" alt="Benecke Group Overview" className="rounded-lg w-full object-cover" />
        </div>
      </section>

      {/* SECTION 2: Rita – Blue background, image left, text right */}
      <section className="bg-primary text-white py-20 px-6">
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center"
          data-aos="fade-up"
        >
          <img src="/rita_new.jpg" alt="Rita Benecke" className="rounded-lg w-full object-cover" />
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Rita Benecke</h2>
            <p className="text-lg leading-relaxed">
              Rita is the heart of the Benecke Group — a pioneer in sustainability and community upliftment long before it became trendy. She championed eco-conscious practices, supported local suppliers, and believed in giving opportunities to those from underserved communities. Her influence remains at the core of the Group’s values today.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3: Johan – White background, text left, image right */}
      <section className="bg-white py-20 px-6">
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center"
          data-aos="fade-up"
        >
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Johan Benecke</h2>
            <p className="text-lg leading-relaxed">
              As a natural leader and entrepreneur, Johan combines business smarts with a big heart and continues the family legacy with a strong focus on innovation, growth, and community upliftment. He has served as Managing Director since 2010 and has built long-standing relationships with guests and partners, and ensures that each Benecke property reflects their commitment to quality and hospitality.
            </p>
          </div>
          <img src="/johan_new.jpg" alt="Johan Benecke" className="rounded-lg w-full object-cover" />
        </div>
      </section>

      {/* SECTION 4: Elgro Legacy – Blue background, image left, text right */}
      <section className="bg-primary text-white py-20 px-6">
        <div
          className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center"
          data-aos="fade-up"
        >
          <img src="/elgro-inn-hotel.jpg" alt="Elgro story article" className="rounded-lg w-full h-[500px] object-cover" />
          <div>
            <h2 className="text-4xl font-bold mb-6">The Story Behind Elgro Inn Hotel</h2>
            <p className="text-lg leading-relaxed mb-4">
              The name <span className="text-[#FEB339] font-bold">ELGRO</span> is more than just a brand — it's a tribute to the women who helped build its legacy...
            </p>
            <ul className="list-disc ml-6 text-white/90 text-base space-y-1">
              <li><strong className="text-[#FEB339]">E</strong>lsa</li>
              <li><strong className="text-[#FEB339]">L</strong>ettie</li>
              <li><strong className="text-[#FEB339]">G</strong>rieta</li>
              <li><strong className="text-[#FEB339]">R</strong>ita</li>
              <li><strong className="text-[#FEB339]">O</strong>na</li>
            </ul>
            <p className="text-lg mt-4 text-white/90">
              This name was first featured in an issue of <em>Die Huisgenoot</em> dated 15 December 1967, where the Elgro Hotel in Bothaville was highlighted as a luxurious destination for travelers and families.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5: Centered final photo – White background */}
      <section className="bg-white py-20 px-6">
        <div className="max-w-4xl mx-auto text-center" data-aos="fade-up">
          <img
            src="/rita_johan_spur.jpg"
            alt="Benecke Family"
            className="rounded-lg w-full max-w-3xl mx-auto mb-6 object-cover"
          />
          <p className="text-lg leading-relaxed text-[#144E73]">
            Built on Family, Powered by Purpose.
          </p>
        </div>
      </section>

      {/* Spacer before footer */}
      <div className="bg-white py-12"></div>
    </div>
  );
};

export default People;